import { Section } from '../types/yellowHiveTypes';

const YINCO_LOGO = 'https://yinco.nl/application/files/6217/5274/1142/480.png';
const CTA_BEHEREN = 'https://adviseur.yinco.nl/';
const CTA_AANVRAGEN_ZAK = 'https://zakelijkvergelijken.yinco.nl/';

export const bedrijfsmatigSections: Section[] = [
  {
    id: 'recht-en-plicht',
    title: 'Recht en plicht',
    iconType: 'Scale',
    products: [
      {
        id: 'bedrijfsaansprakelijkheidsverzekering',
        name: 'Bedrijfsaansprakelijkheidsverzekering (AVB)',
        category: 'Bedrijfsmatig',
        section: 'recht-en-plicht',
        tags: ['mkb'],
        description:
          'Dekt aansprakelijkheid voor letsel/zaakschade bij derden door bedrijf, medewerkers of producten.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'bestuurdersaansprakelijkheidsverzekering',
        name: 'Bestuurdersaansprakelijkheidsverzekering (D&O)',
        category: 'Bedrijfsmatig',
        section: 'recht-en-plicht',
        tags: ['mkb'],
        description:
          'Beschermt bestuurders/commissarissen tegen persoonlijke aansprakelijkheidsclaims uit hun functie.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'beroepsaansprakelijkheidsverzekering',
        name: 'Beroepsaansprakelijkheidsverzekering (BAV)',
        category: 'Bedrijfsmatig',
        section: 'recht-en-plicht',
        tags: ['zzp', 'mkb'],
        description:
          'Verzekert financiële gevolgen van beroepsfouten en juridische kosten (o.a. adviseurs/IT/juridisch).',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
  {
    id: 'continuiteit',
    title: 'Bedrijfscontinuïteit',
    iconType: 'Wallet',
    products: [
      {
        id: 'bedrijfsschadeverzekering',
        name: 'Bedrijfsschadeverzekering',
        category: 'Bedrijfsmatig',
        section: 'continuiteit',
        tags: ['mkb', 'continuiteit'],
        description:
          'Vergoedt vaste kosten en brutowinst/omzetverlies na o.a. brand of waterschade.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'exploitatiekostenverzekering',
        name: 'Exploitatiekostenverzekering',
        category: 'Bedrijfsmatig',
        section: 'continuiteit',
        tags: ['mkb', 'continuiteit'],
        description:
          'Vergoedt noodzakelijke extra/doorlopende kosten na gedekte schade om het bedrijf draaiende te houden.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'extra-kosten-verzekering',
        name: 'Extra kosten verzekering',
        category: 'Bedrijfsmatig',
        section: 'continuiteit',
        tags: ['mkb', 'continuiteit'],
        description:
          'Dekt extra kosten bij schade aan gebouw/inventaris/goederen; niet de brutowinst.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'milieuschadeverzekering',
        name: 'Milieuschadeverzekering',
        category: 'Bedrijfsmatig',
        section: 'continuiteit',
        tags: ['mkb', 'milieu'],
        description:
          'Dekt aansprakelijkheid/saneringskosten bij milieuschade (plots/gradueel, afhankelijk van polis).',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'cyberverzekering',
        name: 'Cyberverzekering',
        category: 'Bedrijfsmatig',
        section: 'continuiteit',
        tags: ['mkb'],
        description:
          'Hulp en kosten bij cyberincidenten, o.a. datalek, ransomware en aansprakelijkheid.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_BEHEREN,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
  {
    id: 'bezittingen',
    title: 'Bezittingen',
    iconType: 'Building2',
    products: [
      {
        id: 'computer-en-elektronica',
        name: 'Computer- en elektronicaverzekering',
        category: 'Bedrijfsmatig',
        section: 'bezittingen',
        tags: ['mkb', 'bezittingen'],
        description:
          'Dekt schade aan (bedrijfs)apparatuur op locatie; uitbreidbaar buiten het bedrijf.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'bedrijfsgebouwenverzekering',
        name: 'Bedrijfsgebouwenverzekering',
        category: 'Bedrijfsmatig',
        section: 'bezittingen',
        tags: ['mkb', 'vastgoed', 'bezittingen'],
        description:
          'Dekt schade aan bedrijfsgebouw; vaak te combineren met glas/huurdersbelang.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'glasverzekering-zakelijk',
        name: 'Glasverzekering zakelijk',
        category: 'Bedrijfsmatig',
        section: 'bezittingen',
        tags: ['mkb', 'vastgoed', 'bezittingen'],
        description: 'Dekt glasschade; snelle ruitvervanging en afhandeling.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'inventaris-en-goederenverzekering',
        name: 'Inventaris- en goederenverzekering',
        category: 'Bedrijfsmatig',
        section: 'bezittingen',
        tags: ['mkb', 'bezittingen'],
        description:
          'Dekt schade aan inventaris, handelsvoorraad en grond-/hulpstoffen.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'geldverzekering',
        name: 'Geldverzekering',
        category: 'Bedrijfsmatig',
        section: 'bezittingen',
        tags: ['mkb', 'bezittingen'],
        description:
          'Dekt verlies/diefstal van geld op locatie, thuis of tijdens direct vervoer.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
  {
    id: 'onderweg',
    title: 'Onderweg',
    iconType: 'Car',
    products: [
      {
        id: 'aanhangwagenverzekering-zakelijk',
        name: 'Aanhangwagenverzekering (zakelijk)',
        category: 'Bedrijfsmatig',
        section: 'onderweg',
        tags: ['transport', 'onderweg'],
        description:
          'Dekt schade aan de zakelijke aanhangwagen; WA via trekkend voertuig.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'eigen-vervoerverzekering',
        name: 'Eigen vervoerverzekering',
        category: 'Bedrijfsmatig',
        section: 'onderweg',
        tags: ['transport', 'onderweg'],
        description:
          'Voor eigen vervoer van goederen/gereedschap in eigen voertuigen.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'goederentransportverzekering',
        name: 'Goederentransportverzekering',
        category: 'Bedrijfsmatig',
        section: 'onderweg',
        tags: ['transport', 'onderweg'],
        description: 'Voor schade aan goederen tijdens transport door derden.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'personenautoverzekering-zakelijk',
        name: 'Personenautoverzekering (zakelijk)',
        category: 'Bedrijfsmatig',
        section: 'onderweg',
        tags: ['transport', 'onderweg'],
        description:
          'WA (verplicht) + casco-opties voor zakelijke personenauto’s.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'bestelautoverzekering-zakelijk',
        name: 'Bestelautoverzekering',
        category: 'Bedrijfsmatig',
        section: 'onderweg',
        tags: ['transport', 'onderweg'],
        description:
          'WA (verplicht) + casco-opties voor bestelauto’s; acceptatie o.b.v. leeftijd/gebruik.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'vrachtautoverzekering',
        name: 'Vrachtautoverzekering',
        category: 'Bedrijfsmatig',
        section: 'onderweg',
        tags: ['transport'],
        description: 'WA (verplicht) + casco-opties voor vrachtauto’s.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'zakenreisverzekering',
        name: 'Zakenreisverzekering',
        category: 'Bedrijfsmatig',
        section: 'onderweg',
        tags: ['mkb', 'reizen', 'onderweg'],
        description:
          'Dekking voor zakelijke reizen (noodhulp, medische kosten, extra kosten/annulering).',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'verkeersschadeverzekering-werknemers',
        name: 'Verkeersschadeverzekering (voor werknemers)',
        category: 'Bedrijfsmatig',
        section: 'onderweg',
        tags: ['mkb'],
        description:
          'Uitkeringen bij verkeersongevallen tijdens werkgerelateerd verkeer (werknemers en inleners).',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'werk-en-landbouwmaterieelverzekering',
        name: 'Werk- en landbouwmaterieelverzekering',
        category: 'Bedrijfsmatig',
        section: 'onderweg',
        tags: ['mkb'],
        description:
          'Dekt schade aan (zelfrijdend) land-/werkmaterieel; WA verplicht op de openbare weg.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
  {
    id: 'inkomen',
    title: 'Inkomen',
    iconType: 'Wallet',
    products: [
      {
        id: 'collectieve-ongevallenverzekering',
        name: 'Collectieve ongevallenverzekering',
        category: 'Bedrijfsmatig',
        section: 'inkomen',
        tags: ['mkb'],
        description:
          'Keert uit bij (werk)ongevallen van personeel; collectieve voorwaarden beschikbaar.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
  {
    id: 'bouw-montage',
    title: 'Bouw & montage',
    iconType: 'Building2',
    products: [
      {
        id: 'car-verzekering',
        name: 'CAR-verzekering',
        category: 'Bedrijfsmatig',
        section: 'bouw-montage',
        tags: ['mkb'],
        description:
          'Dekt schade tijdens bouw/verbouw aan werk, materialen en aansprakelijkheid tijdens uitvoering.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
      {
        id: 'montageverzekering',
        name: 'Montageverzekering',
        category: 'Bedrijfsmatig',
        section: 'bouw-montage',
        tags: ['mkb'],
        description:
          'Dekt schade aan te monteren installaties/materiaal tijdens montageperiode.',
        logo: YINCO_LOGO,
        ctaRequestUrl: CTA_AANVRAGEN_ZAK,
        ctaManageUrl: CTA_BEHEREN,
      },
    ],
  },
  {
    id: 'specialties',
    title: 'Specialties',
    iconType: 'Building2',
    products: [
      {
        id: 'vve-pakket',
        name: 'VvE Pakket (alleen per mail)',
        category: 'Bedrijfsmatig',
        section: 'specialties',
        tags: ['vastgoed', 'vve'],
        description:
          'Bundel voor VvE’s met o.a. opstal, glas, AVP onroerend goed en rechtsbijstand.',
        logo: YINCO_LOGO,
        ctaRequestUrl: 'mailto:acceptatiezakelijk@yinco.nl',
      },
      {
        id: 'horeca-pakket-apc',
        name: 'Horeca pakket (APC Holland)',
        category: 'Bedrijfsmatig',
        section: 'specialties',
        tags: ['mkb'],
        description:
          'Verzekeringspakket speciaal voor horeca-ondernemingen (zaak, aansprakelijkheid, inventaris e.d.).',
        logo: 'https://www.apcholland.nl/wp-content/themes/apc-holland/dist/images/general/logo.svg',
        ctaRequestUrl: 'https://www.apcholland.nl/product/horeca/',
        ctaManageUrl: 'https://www.apcholland.nl/producten/regelen/',
      },
      {
        id: 'tvo-apc',
        name: 'Totaalpakket voor Ondernemers (APC TVO)',
        category: 'Bedrijfsmatig',
        section: 'specialties',
        tags: ['mkb'],
        description:
          'Modulair totaalpakket voor MKB met kern- en aanvullende dekkingen per branche.',
        logo: 'https://www.apcholland.nl/wp-content/themes/apc-holland/dist/images/general/logo.svg',
        ctaRequestUrl: 'https://www.apcholland.nl/product/tvo/',
        ctaManageUrl: 'https://www.apcholland.nl/producten/regelen/',
      },
      {
        id: 'pog-apc',
        name: 'Particulier onroerend goed pakket (APC POG)',
        category: 'Bedrijfsmatig',
        section: 'specialties',
        tags: ['vastgoed'],
        description:
          'Pakket voor particuliere verhuur/bezit van vastgoed met brede dekking.',
        logo: 'https://www.apcholland.nl/wp-content/themes/apc-holland/dist/images/general/logo.svg',
        ctaRequestUrl: 'https://www.apcholland.nl/product/pog/',
        ctaManageUrl: 'https://www.apcholland.nl/producten/regelen/',
      },
      {
        id: 'vog-apc',
        name: 'Verhuurd onroerend goed pakket (APC VOG)',
        category: 'Bedrijfsmatig',
        section: 'specialties',
        tags: ['vastgoed'],
        description:
          'Pakket voor beleggings/huurvastgoed met dekking voor object en aansprakelijkheid.',
        logo: 'https://www.apcholland.nl/wp-content/themes/apc-holland/dist/images/general/logo.svg',
        ctaRequestUrl: 'https://www.apcholland.nl/product/vog/',
        ctaManageUrl: 'https://www.apcholland.nl/producten/regelen/',
      },
      {
        id: 'vtom-apc',
        name: 'Verzuim Totaal Op Maat (APC VTOM)',
        category: 'Bedrijfsmatig',
        section: 'specialties',
        tags: ['mkb'],
        description:
          'Verzuimoplossing met preventie, interventie en dekking van loondoorbetaling.',
        logo: 'https://www.apcholland.nl/wp-content/themes/apc-holland/dist/images/general/logo.svg',
        ctaRequestUrl: 'https://www.apcholland.nl/product/vtom/',
        ctaManageUrl: 'https://www.apcholland.nl/producten/regelen/',
      },
      {
        id: 'msv-apc',
        name: 'Milieuschadeverzekering (APC MSV)',
        category: 'Bedrijfsmatig',
        section: 'specialties',
        tags: ['mkb'],
        description:
          'Dekt milieuschade en saneringskosten conform polisvoorwaarden.',
        logo: 'https://www.apcholland.nl/wp-content/themes/apc-holland/dist/images/general/logo.svg',
        ctaRequestUrl: 'https://www.apcholland.nl/product/msv/',
        ctaManageUrl: 'https://www.apcholland.nl/producten/regelen/',
      },
      {
        id: 'apc-collectieve-coverproducten',
        name: 'Collectieve coverproducten (APC)',
        category: 'Bedrijfsmatig',
        section: 'specialties',
        tags: ['mkb'],
        description:
          'Overzicht van collectieve verzekeringsoplossingen die via APC geregeld kunnen worden.',
        logo: 'https://www.apcholland.nl/wp-content/themes/apc-holland/dist/images/general/logo.svg',
        ctaRequestUrl: 'https://www.apcholland.nl/product/coverproducten/',
        ctaManageUrl: 'https://www.apcholland.nl/producten/regelen/',
      },
    ],
  },
];
